import { channelPartnerWebhookQueryKeys as e } from "./useChannelPartnerWebhookQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminChannelPartnerWebhooksApi as n } from "@maat/api-main";
//#region src/channelPartnerWebhooks/useChannelPartnerDeliveryStatsQuery.ts
var r = (r = {}, i = !0) => t({
	queryKey: e.deliveryStats(r),
	queryFn: () => n.deliveryStats(r),
	enabled: i
});
//#endregion
export { r as useChannelPartnerDeliveryStatsQuery };
